// 名医入住
import { post, get, deletefn, putfun } from './http.js'
export default {
  // 名医信息编辑
  async expert_put (params) {
    return await putfun (`/user/expert/${params.id}`,params)
  },
  // 名医信息提交
  async expert_post (params) {
    return await post ('/user/expert',params)
  },
  /*名医信息拉取*/
  async expert_get (params) {
    return await get (`/user/expert/${params}`)
  },
  /*名医分类*/
  async expert_categories (params) {
    return await get (`/expert-categories`)
  },
  /*名医特长*/
  async expert_speciality (data) {
    return await get (`/expert-speciality`,data)
  },
  /*名医承诺书下载*/
  async expert_download(params) {
    return await post (`/user/expert-download`,params)
  },
  /*答疑列表*/
  async expert_question_list (params) {
    return await get (`/expert-question`,params)
  },
  /*推荐专家*/
  async expert_list (params) {
    return await get (`/expert`,params)
  },
  /*专家详情*/
  async expert_detail (params) {
    return await get (`/expert/${params}`)
  },
  /*发布*/
  async question_release (params) {
    return await post (`/expert-question`,params)
  },
  /* 追问 */
  async question_releasing (params) {
    return await post (`/expert-questioning`,params)
  },
  /* 我的回答 */
  async answer_my (params) {
    return await get (`/expert-question/inquiry/owner`,params)
  },
  /* 问题详情 */
  async answer_detail (params) {
    return await get (`/expert-question/${params}`,'')
  },
  /* 专家回答 */
  async answer_question (params) {
    return await post (`/expert-answer`,params)
  },
  /* 专家操作 */
  async answer_options (params) {
    return await post (`/expert-question/${params.id}`,params)
  },
  /* 拒绝 */
  async answer_refuse (params) {
    return await post (`/expert-question/${params.id}`,params)
  },
}



// WEBPACK FOOTER //
// ./src/request/expert.js